import React, { Component } from "react";
import quoteSrc from "../../assets/img/quote.png";
import { connect } from "react-redux";
import { getSystemFeedbacks } from "../../actions/webinars";

class FeedbackCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0,
    };
  }

  componentDidMount() {
    this.props.getSystemFeedback({ page: 1, per_page: 7 });
    this.setReloadInterval();
  }

  componentWillUnmount() {
    this.clearReloadInterval();
  }

  setReloadInterval = () => {
    this.reloadInterval = setInterval(() => {
      if (this.props.feedbacks.data.length > 0) {
        this.setState({
          current:
            this.state.current === this.props.feedbacks.data.length - 1
              ? 0
              : this.state.current + 1,
        });
      }
    }, 5000);
  };

  clearReloadInterval = () => {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  };

  onClick = (idx) => {
    this.setState({ current: idx });
  };

  render() {
    const { current } = this.state;
    const { data } = this.props.feedbacks;

    if (!data.length) {
      return null;
    }

    return (
      <div className="feedback-carousel" style={this.props.style}>
        <Feedback {...data[current]} />
        <div className="feedback-button-list">
          {data.map((_, idx) => (
            <Button
              onClick={() => this.onClick(idx)}
              key={idx}
              isActive={idx === current}
            />
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedbacks: state.webinars.systemFeedbacks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSystemFeedback: (params) => dispatch(getSystemFeedbacks(params)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackCarousel);

const Feedback = ({ body, user_name }) => (
  <div className="feedback">
    <div className="feedback-content-container">
      <img src={quoteSrc} className="feedback-quote rotate" />
      <div className="feedback-content">{body}</div>
      <img src={quoteSrc} className="feedback-quote" />
    </div>
    <div className="feedback-content-author-container">
      <div className="feedback-quote" />
      <div className="feedback-content-author">{user_name}</div>
      <div className="feedback-quote" />
    </div>
  </div>
);

const Button = ({ onClick, isActive }) => (
  <button
    onClick={onClick}
    className={`feedback-button ${isActive && "active"}`}
  />
);



// WEBPACK FOOTER //
// ./src/containers/FeedbackCarousel/index.jsx